import React, { useState } from 'react';
import {
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  TextFieldProps,
} from '@material-ui/core';
import {
  Visibility as ShowPasswordIcon,
  VisibilityOff as HidePasswordIcon,
} from '@material-ui/icons';

const PasswordTextField: React.FC<TextFieldProps> = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <Tooltip title={showPassword ? 'Hide password' : 'Show password'}>
              <IconButton onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <ShowPasswordIcon /> : <HidePasswordIcon />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      type={showPassword ? 'text' : 'password'}
    />
  );
};

export default PasswordTextField;
